module.exports = __webpack_public_path__ + "img/palmar-pool.3c189ecf.jpg";